import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getZipcode } from 'helpers/Zipgate';
import { RootState } from 'redux/store';
import Cookies from 'universal-cookie';
const isHonda = process.env.REACT_APP_THEME === 'honda';
const Acr = window.Acr || undefined;
const cookies = new Cookies();
let initialState: string = Acr
  ? Acr.zipgateComponent.getZipcode()
  : getZipcode();
export const zipcodeSlice = createSlice({
  name: 'zipcode',
  initialState,
  reducers: {
    setZipcode: (state, action: PayloadAction<string>) => {
      if (!isHonda) {
        localStorage.setItem('userZipCode', action.payload);
      } else {
        cookies.set('zipcode', action.payload, { path: '/', secure: true });
      }
      return (state = action.payload as string);
    },
  },
});

export const { setZipcode } = zipcodeSlice.actions;

export const selectZipcode = (state: RootState) => state.zipcode;

export default zipcodeSlice.reducer;
